import { FunctionComponent, useState, useCallback, ChangeEvent } from 'react'
import { MdPlayArrow } from 'react-icons/md'
import { useHistory } from 'react-router-dom'

import * as Yup from 'yup'

import iconKey from 'shared/assets/icons/icon-key.svg'
import Form, { IProps as FormProps } from 'shared/components/Form'
import Input from 'shared/components/Input'
import { colors } from 'shared/styles/colors'

import { IResetPassword } from '../../domain/usecases/ResetPasswordImpl'
import {
  ContainerForm,
  StyledButton,
  StyledPage,
  StyledFeedback,
  StyledCenter,
} from './styles'

type TProps = {
  resetPassword: IResetPassword
}

const Forgot: FunctionComponent<TProps> = ({ resetPassword }) => {
  const history = useHistory()
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [emailOk, setEmailOk] = useState(false)
  const [resetPasswordOk, setResetPasswordOk] = useState(false)

  const handleSubmit = useCallback(
    async (values: FormProps['values']) => {
      setLoading(true)
      setErrorMessage('')

      try {
        const response = await resetPassword.execute({ email: values.email })
        if (response.error) {
          setErrorMessage(response.message)
          setLoading(false)
          return
        }

        setResetPasswordOk(true)
      } catch (e: unknown) {
        setResetPasswordOk(true)
        setErrorMessage(
          `Erro ao redefinir sua senha ${e instanceof Error && e.message}`,
        )
        setLoading(false)
      }
    },
    [resetPassword],
  )

  const handleChange = useCallback(async (e: ChangeEvent<HTMLInputElement>) => {
    setEmailOk(false)

    if (!e.target.value) return

    try {
      const schema = Yup.object().shape({
        email: Yup.string().email('Digite um e-mail válido'),
      })

      await schema.validate(
        {
          email: e.target.value,
        },
        {
          abortEarly: false,
        },
      )

      setEmailOk(true)
    } catch (e: unknown) {
      setEmailOk(false)
    }
  }, [])

  if (resetPasswordOk)
    return (
      <StyledCenter>
        <StyledFeedback
          colorIcon={colors.white}
          sizeIcon={70}
          title="Solicitação enviada com sucesso!"
          subTitle="Caso haja um usuário cadastrado com esse email, ele receberá a redefinição de senha no e-mail informado."
          onClickButton={() => {
            history.push('/')
          }}
        />
      </StyledCenter>
    )

  return (
    <StyledPage
      icon={iconKey}
      title="Para recuperar a senha, digite seu email:"
    >
      <div style={{ display: 'flex', justifyContent: 'center', flex: 1 }}>
        <Form
          onSubmit={handleSubmit}
          initialValues={{ email: '' }}
          validationSchema={() => ({
            email: Yup.string().email('Email inválido!').required(),
          })}
        >
          {formControl => (
            <ContainerForm>
              <Input
                placeholder="Digite seu e-mail"
                name="email"
                type="email"
                mask={value => value.toLowerCase()}
                formControl={formControl}
                errorMessage={errorMessage}
                onChange={handleChange}
              />

              <StyledButton
                color={emailOk ? colors.green : colors.grayLight}
                type="submit"
                onClick={formControl.handleSubmit}
                loading={loading}
                disabled={!emailOk || loading}
              >
                <MdPlayArrow /> Enviar
              </StyledButton>
            </ContainerForm>
          )}
        </Form>
      </div>
    </StyledPage>
  )
}

export default Forgot
